import React from 'react';
import { useTranslation } from 'react-i18next';
import { clrs } from '../../../constants/colors';

// ru/kk/en switcher. Совместим со старой схемой localStorage 'lan' (РУС/ҚАЗ/ENG),
// которую читает src/lang/index.js при инициализации.
const LANGS = [
    { code: 'ru', label: 'РУС', store: 'РУС' },
    { code: 'kk', label: 'ҚАЗ', store: 'ҚАЗ' },
    { code: 'en', label: 'ENG', store: 'ENG' },
];

const LanguageSwitcher = ({ vertical = false }) => {
    const { i18n } = useTranslation();
    const current = (i18n.language || 'ru').slice(0, 2);

    const change = (lang) => {
        localStorage.setItem('lan', lang.store);
        i18n.changeLanguage(lang.code);
    };

    return (
        <div
            style={{
                display: 'inline-flex',
                flexDirection: vertical ? 'column' : 'row',
                gap: 2,
                padding: 3,
                borderRadius: 10,
                border: `1px solid ${clrs.greenLight}`,
                background: 'rgba(255,255,255,0.08)',
            }}
        >
            {LANGS.map((lang) => {
                const active = current === lang.code;
                return (
                    <button
                        key={lang.code}
                        type="button"
                        onClick={() => change(lang)}
                        aria-pressed={active}
                        style={{
                            cursor: 'pointer',
                            border: 'none',
                            borderRadius: 7,
                            padding: '4px 11px',
                            fontSize: '0.8rem',
                            fontWeight: 700,
                            lineHeight: 1.2,
                            background: active ? clrs.greenLight : 'transparent',
                            color: active ? clrs.blue : clrs.greenLight,
                            transition: 'background 0.15s, color 0.15s',
                        }}
                    >
                        {lang.label}
                    </button>
                );
            })}
        </div>
    );
};

export default LanguageSwitcher;
